import { IoClose } from "react-icons/io5";
import style from "./ErrorModal.module.scss";

export function ErrorModal({
    title,
    description,
    closeModal,
    button
}: {
    title: string,
    description: string | JSX.Element,
    closeModal?: () => void,
    button?: { text: string | JSX.Element, action: () => void }
}) {
    return (
        <div className={style.backing}>
            <div className={style.container}>
                <IoClose
                    className="absolute right-[15px] top-[15px] w-[15px] h-[15px] cursor-pointer"
                    onClick={closeModal}
                />
                <img src="/image/error.png" alt="error" />
                <div className={style.content}>
                    <p className={style.title}>{title}</p>
                    <div className={style.description}>{description}</div>
                    <button
                        type="button"
                        onClick={() => {
                            if (button) {
                                button?.action()
                            } else {
                                closeModal?.()
                            }
                        }}
                    >
                        {button?.text || "Закрити"}
                    </button>
                </div>
            </div>
        </div>
    )
}